import { registerLocaleData } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppComponent } from './app.component'

import localeNL_NL from '@angular/common/locales/nl'
import localeNL_NL_Extra from '@angular/common/locales/extra/nl'

import localeFR_FR from '@angular/common/locales/fr'
import localeFR_FR_Extra from '@angular/common/locales/extra/fr'

import localeDE_DE from '@angular/common/locales/de'
import localeDE_DE_Extra from '@angular/common/locales/extra/de'

import localeDA_DK from '@angular/common/locales/da'
import localeDA_DK_Extra from '@angular/common/locales/extra/da'
import { FrameworkModule } from '../../../framework/framework.module'
import { RoutingLoadingStatusModule } from '../../../ui/navigation/routing-loading-status/routing-loading-status.module'
import { UiModule } from '../../../ui/monolith/ui.module'
import { RouterModule } from '@angular/router'
import { RollbarErrorHandler, rollbarFactory, RollbarService } from '../../../framework/rollbar/rollbar.service'

registerLocaleData(localeNL_NL, 'nl', localeNL_NL_Extra)
registerLocaleData(localeFR_FR, 'fr', localeFR_FR_Extra)
registerLocaleData(localeDE_DE, 'de', localeDE_DE_Extra)
registerLocaleData(localeDA_DK, 'dk', localeDA_DK_Extra)

@NgModule({
    declarations: [AppComponent],
    providers: [
        {
            provide: ErrorHandler,
            useClass: RollbarErrorHandler,
        },
        {
            provide: RollbarService,
            useFactory: rollbarFactory,
        },
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        UiModule,

        FrameworkModule,
        RoutingLoadingStatusModule,

        RouterModule.forRoot([], {
            initialNavigation: 'enabledNonBlocking',
            enableTracing: false,
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled',
        }),
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
    exports: [RouterModule],
})
export class BootstrapModule {
    constructor() {}
}
